import * as React from 'react';
import { useHeaderRowContext } from '../../../HeaderRow/context/hooks/useHeaderRowContext.js';

/**
 * Hook to register the search field button with header row context
 */
var useRegisterSearchFieldButton = function useRegisterSearchFieldButton() {
  var _useHeaderRowContext = useHeaderRowContext(),
    setHasSearchFieldButton = _useHeaderRowContext.setHasSearchFieldButton;
  React.useEffect(function () {
    // Register the button's presence when the component mounts
    setHasSearchFieldButton === null || setHasSearchFieldButton === void 0 || setHasSearchFieldButton(true);

    // This cleanup function runs when the component unmounts
    // It signals to the header row context that the search button is no longer present
    // The optional chaining (?.) ensures this only runs if setHasSearchFieldButton exists
    return function () {
      return setHasSearchFieldButton === null || setHasSearchFieldButton === void 0 ? void 0 : setHasSearchFieldButton(false);
    };
  }, [setHasSearchFieldButton]);
};

export { useRegisterSearchFieldButton };
//# sourceMappingURL=useRegisterSearchFieldButton.js.map
